import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BookOpen, ChevronDown, ChevronUp } from "lucide-react";

export const NotePracticeAnswers = ({ teacherId }) => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    if (!teacherId) return;
    fetch(`/api/ai-lessons/note-answers?teacher_id=${teacherId}`, { headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } })
      .then(r => (r.ok ? r.json() : { answers: [] }))
      .then(d => setRows(d.answers || []))
      .catch(() => setRows([]));
  }, [teacherId]);

  if (rows.length === 0) return null;

  return (
    <Card data-testid="note-practice-answers">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><BookOpen className="h-4 w-4 text-emerald-600" /> Study Notes — Practice Question Answers <Badge variant="secondary">{rows.length}</Badge></CardTitle>
        <p className="text-xs text-slate-500">Answers students submitted on your shared AI study notes. Exact matches are counted automatically; read the rest yourself.</p>
      </CardHeader>
      <CardContent className="divide-y">
        {rows.map(r => (
          <div key={r.id} className="py-2" data-testid={`note-answer-${r.id}`}>
            <button className="w-full flex items-center justify-between text-left" onClick={() => setOpen(open === r.id ? null : r.id)} data-testid={`note-answer-toggle-${r.id}`}>
              <div>
                <span className="font-medium text-slate-900">{r.student_name}</span>
                <span className="text-slate-500 text-sm"> · Year {r.year_level} {r.subject} · {r.note_title}</span>
                <div className="text-xs text-slate-500">{r.completed_at ? new Date(r.completed_at).toLocaleString() : ''} · {r.exact_matches}/{r.total} exact matches</div>
              </div>
              {open === r.id ? <ChevronUp className="h-4 w-4 text-slate-400" /> : <ChevronDown className="h-4 w-4 text-slate-400" />}
            </button>
            {open === r.id && (
              <ol className="mt-2 space-y-2 text-sm list-decimal pl-5">
                {r.answers.map((a, i) => (
                  <li key={i}>
                    <div className="text-slate-700">{a.question}</div>
                    <div className="text-emerald-700"><span className="text-slate-500">Student:</span> {a.student_answer || '—'}</div>
                    {a.correct_answer && <div className="text-slate-500 text-xs">Model answer: {a.correct_answer}</div>}
                  </li>
                ))}
              </ol>
            )}
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
